import React from 'react';
import "./CTA.css";
import {Link} from "react-router-dom";

const CTA = () => {
  return (
    <div className='cta section-p' id="cta">
        <div className='container'>
            <div className='cta-content text-center'>
                <h3 className='text-white'>¿Listo para asegurar tu renta mensual?</h3>
                <Link to="/contact" className='btn-item bg-brown fw-4 ls-2'>Quiero una valoración gratuita de mi vivienda</Link>
            </div>
        </div>
    </div>
  )
}

export default CTA